import { useState } from 'react';
import axios from 'axios';
import { useNavigate } from "react-router-dom";
import { NotificationManager } from 'react-notifications';
import { useMsal } from '@azure/msal-react';
import useFetchVendors from './useFetchVendors';
import { msalConfig } from '../auth/authConfig';
import { errorHandler } from '../utils/helpers';
import useUserStore from '../store/userStore';
import { acquireToken } from '../utils/auth';

interface CreateVendorContactRequest {
  token: string | null;
  setError: (data: any) => any;
  setLoading: (data: any) => any;
  fetchVendors: () => any;
  data: CreateVendorContactDTO;
};

const createVendorContactRequest = async ({
    token,
    setError,
    setLoading,
    fetchVendors,
    data,
  }: CreateVendorContactRequest) => {
  try {
    const response = await axios.post(`${window.__env.REACT_APP_API_URL || process.env.REACT_APP_API_URL}/Vendor/Contact`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: 'application/json, text/plain, */*',
      },
    });
    if (response.status === 200) {
      NotificationManager.success('Vendor Contact is successfully created');
    }
  } catch (error) {
    errorHandler(error, setError);
  } finally {
    fetchVendors();
    setLoading(false);
  }
};

interface CreateVendorContactDTO { name: string, email: string, phoneNumber: string, vendorId: number };

interface CreateVendorContact {
  createVendorContact: (formData: CreateVendorContactDTO) => void;
  loading: boolean;
  error: Error | null;
};

const useCreateVendorContact = (): CreateVendorContact => {
  const navigate = useNavigate();
  const { instance, accounts } = useMsal();
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<Error | null>(null);
  const { fetchVendors } = useFetchVendors();
  
  const { user } = useUserStore();

  const createVendorContact = async (formData: CreateVendorContactDTO) => {
    if (accounts.length > 0) {
      const accessTokenRequest = {
        scopes: [`${msalConfig.auth.clientId}/.default`],
        account: accounts[0],
      };

      if (!user) return navigate('/sign-in');

      const data: CreateVendorContactDTO = formData;

      try {
        const accessToken = await acquireToken(instance, accessTokenRequest);
        createVendorContactRequest({
          token: accessToken,
          setError,
          fetchVendors,
          setLoading,
          data,
        });
      } catch (error) {
        errorHandler(error, setError);
      }
    } else {
      navigate('/sign-in');
    }
  }

  return { createVendorContact, loading, error };
};

export default useCreateVendorContact;
